import React, { useReducer, useEffect } from 'react';
import { Card, Button, Container, Row, Col, Modal, Image } from 'react-bootstrap';
import Switch from 'react-switch';
import DateTimePicker from 'react-datetime-picker';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import parse from 'html-react-parser';
import moment from 'moment';
import firebase from 'firebase';
import 'firebase/firestore';

import PushNotification from './notification';
import Editor from './editor';
import './article.scss';

const initialState = {
    showArticle: false,
    renderState: '',
    editorState: false,
    publicationButton: '',
    schedule: {
        begin: Date.now(),
        end: new Date().getTime() + 86400000,
    },
    scheduleState: false,
}

const articleReducer = (article, action) => {
    switch (action.type) {
        case 'HANDLE_SHOW_ARTICLE':
            return { ...article, showArticle: action.showArticle };
        case 'HANDLE_SHOW_EDITOR':
            return { ...article, editorState: action.editorState };
        case 'HANDLE_SHOW_NOTIFICATION':
            return { ...article, notificationState: action.notificationState };
        case 'HANDLE_PUBLICATION_PARAMS':
            return { ...article, renderState: action.renderState, publicationButton: action.publicationButton }
        case 'HANDLE_SCHEDULING':
            return { ...article, scheduleState: action.scheduleState }
        case 'HANDLE_BEGIN_DATE':
            return { ...article, schedule: { ...article.schedule, begin: action.scheduleBegin } }
        case 'HANDLE_END_DATE':
            return { ...article, schedule: { ...article.schedule, end: action.scheduleEnd } }
        case 'GET_PUBLICATION_STATE':
            return { ...article, state: action.state }
        case 'TOGGLE_PUBLISH':
            return { ...article, state: action.state }
        default:
            return article;
    }
}

const Article = (props) => {
    const { title, subtitle, content, created, updated, state, pictureURL, articleNumber, viewsCount, id } = props.doc;
    const articlesRef = firebase.firestore().collection('articles');

    const [article, dispatch] = useReducer(articleReducer, initialState)

    const handleClose = () => dispatch({ type: 'HANDLE_SHOW_ARTICLE', showArticle: false });
    const handleShow = () => dispatch({ type: 'HANDLE_SHOW_ARTICLE', showArticle: true });
    const closeEditor = () => dispatch({ type: 'HANDLE_SHOW_EDITOR', editorState: false });
    const openEditor = () => dispatch({ type: 'HANDLE_SHOW_EDITOR', editorState: true });
    const closeNotification = () => dispatch({ type: 'HANDLE_SHOW_NOTIFICATION', notificationState: false });
    const openNotification = () => dispatch({ type: 'HANDLE_SHOW_NOTIFICATION', notificationState: true });
    const handlePublicationState = (switchState) => dispatch({ type: 'TOGGLE_PUBLISH', state: switchState });
    const getPublicationState = () => dispatch({ type: 'GET_PUBLICATION_STATE', state: state });

    const handleScheduling = (checked) => {
        console.log('scheduled ? ', checked);
        dispatch({ type: 'HANDLE_SCHEDULING', scheduleState: !article.scheduleState })
    }

    const handleBeginDate = (value) => {
        console.log('changing begin date : ', Date.parse(value));
        dispatch({ type: 'HANDLE_BEGIN_DATE', scheduleBegin: value })
    }

    const handleEndDate = (value) => {
        console.log('changing end date : ', value);
        dispatch({ type: 'HANDLE_END_DATE', scheduleEnd: value })
    }

    const deleteConfirmOptions = {
        title: 'Suppression',
        message: 'Veuillez confirmer la suppression',
        buttons: [
            {
                label: 'Supprimer',
                onClick: () => {
                    try {
                        articlesRef.doc(id).delete();
                    } catch (error) {
                        console.log('error deleting the article : ', error);
                    }
                }
            },
            {
                label: 'Annuler',
                onClick: () => alert('Aucun article supprimé')
            }
        ],
        childrenElement: () => <div />,
        closeOnEscape: true,
        closeOnClickOutside: true,
        willUnmount: () => { },
        onClickOutside: () => { },
        onKeypressEscape: () => { }
    };

    const updateArticleState = (switchState) => {
        handlePublicationState(switchState);

        articlesRef.doc(id).update({
            state: switchState
        });
    }

    const updatePublicationRange = () => {
        if (article.scheduleState) {
            articlesRef.doc(id).update({
                schedule: article.schedule,
            });
        }
    }

    const handleDelete = () => {
        confirmAlert(deleteConfirmOptions);
    }

    useEffect(() => {
        console.log('article state:', state);
        getPublicationState();
    }, []);

    return (
        <div>
            <Card className="article-card">
                <Card.Body onClick={handleShow}>
                    <Row>
                        <Col xs={2}>
                            <Image style={{ width: "100%" }} src={pictureURL} rounded />
                        </Col>
                        <Col xs={6}>
                            <Card.Title className="article-card-title">{title}</Card.Title>
                            <Card.Subtitle className="article-card-subtitle">{subtitle}</Card.Subtitle>
                        </Col>
                        <Col xs={4} className="article-metadata">
                            <p>N° <strong>{articleNumber}</strong></p>
                            <p>Crée le {moment(created).format('DD/MM/YY à HH:mm')}</p>
                            <p>Mis à jour le : {moment(updated).format('DD/MM/YY à HH:mm')}</p>
                            <p>Nombre de vues: {viewsCount}</p>
                        </Col>
                    </Row>

                </Card.Body>
                <Card.Footer className="article-card-footer">
                    <Container>
                        <Row>
                            <Col xs={6} className="controls-block">
                                <Row>
                                    <Switch onChange={updateArticleState} checked={article.state} />
                                    <Button onClick={openEditor}>Modifier</Button>
                                    <Button onClick={openNotification}>Notification</Button>
                                    <Button variant="danger" onClick={handleDelete}>Supprimer</Button>
                                </Row>
                                <Row>
                                    {state ? <p>En ligne</p> : <p>Brouillon</p>}
                                </Row>
                            </Col>
                            <Col xs={2} className="schedule-block">
                                <Row>
                                    <p>Programmer la publication</p>
                                </Row>
                                <Row>
                                    <Switch onChange={handleScheduling} checked={article.scheduleState} />
                                </Row>
                            </Col>
                            <Col xs={4} className="schedule-block">
                                <Row>
                                    {article.scheduleState &&
                                        <div>
                                            <p>Début</p>
                                            <DateTimePicker onChange={handleBeginDate} value={new Date(article.schedule.begin)} />
                                            <p>Fin</p>
                                            <DateTimePicker onChange={handleEndDate} value={new Date(article.schedule.end)} />
                                            <Button onClick={updatePublicationRange} variant="info">Programmer</Button>
                                        </div>
                                    }
                                </Row>
                            </Col>
                        </Row>
                    </Container>
                </Card.Footer>
            </Card>

            {article.notificationState && <PushNotification show={article.notificationState} close={closeNotification} article={{ title, id }} />}

            {article.showArticle && <Modal show={article.showArticle} onHide={handleClose}>
                <Modal.Header>
                    <Col xs={3}>
                        <Image style={{ width: "100%" }} src={pictureURL} rounded />
                    </Col>
                    <Col xs={8}>
                        <Row>
                            <Modal.Title>{title}</Modal.Title>
                        </Row>
                        <Row>
                            <p><strong>{subtitle}</strong></p>
                        </Row>
                        <Row>
                            <p>Crée le {moment(created).format('DD/MM/YY à HH:mm')}</p>
                        </Row>
                        <Row>
                            <p>Mis à jour le : {moment(updated).format('DD/MM/YY à HH:mm')}</p>
                        </Row>
                    </Col>
                    <Col style={{ justifyContent: 'center', alignItems: 'center', margin: 'auto' }}>
                        {state ?
                            <div style={{ width: 30, height: 30, borderRadius: 15, background: 'green' }}></div> :
                            <div style={{ width: 30, height: 30, borderRadius: 15, background: 'grey' }}></div>}
                    </Col>

                </Modal.Header>
                <Modal.Body>{parse(content)}</Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleClose}>Fermer</Button>
                </Modal.Footer>
            </Modal>}

            {article.editorState && <Editor show={article.editorState} close={closeEditor} article={{ title, subtitle, content, id }} />}
        </div>
    )

}

export default Article;